var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    { attrs: { padding: 5 } },
    [
      _c(
        "Box",
        {
          attrs: {
            tag: "header",
            marginBottom: 5,
            display: "flex",
            flexAlign: "center"
          }
        },
        [
          _c(
            "Box",
            [
              _c("LayoutText", { attrs: { fontSize: 4 } }, [
                _vm._v("Engagement Report")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "Box",
        { staticClass: "reports-grid" },
        [
          _c(
            "Card",
            {
              staticClass: "filters",
              attrs: { display: "flex", flexAlign: "center" }
            },
            [
              _c(
                "Box",
                { attrs: { marginRight: 3 } },
                [
                  _c("DateRangePicker", {
                    attrs: { value: _vm.filters.dateRange },
                    on: { input: _vm.setDateRange }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "Card",
            { staticClass: "nopadding" },
            [
              _c("Grid", {
                attrs: {
                  items: _vm.page.events,
                  columns: _vm.columns,
                  loading: _vm.loading,
                  noRecordsMsg: "No Moves to show",
                  pageable: true,
                  skip: _vm.state.offset,
                  pageSize: _vm.state.limit,
                  total: _vm.page.total
                },
                on: { pagechange: _vm.onPageChange },
                scopedSlots: _vm._u([
                  {
                    key: "date",
                    fn: function({ props: { dataItem } }) {
                      return [
                        _c("td", [
                          _vm._v(
                            " " + _vm._s(_vm.formatDate(dataItem.date)) + " "
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }